/**
 * If required to update the styles of the MUI typography variants, do so here.
 */
export const muiTypography = {
  // all muiTypography overrides go here
  useNextVariants: true
}

export default muiTypography
